/** Store Requisition movement types */
export const storeRequisitionMovementTypes = [
  {
    id: "sr_issue_1",
    label: "Issue To Cutting",
    value: "issue_to_cutting",
    movement_type: "outgoing",
  },
  {
    id: "sr_issue_2",
    label: "Issue To Sewing",
    value: "issue_to_sewing",
    movement_type: "outgoing",
  },
  {
    id: "sr_issue_3",
    label: "Issue To Finishing",
    value: "issue_to_folding",
    movement_type: "outgoing",
  },
  {
    id: "sr_issue_4",
    label: "Issue To Packing",
    value: "issue_to_packing",
    movement_type: "outgoing",
  },
  {
    id: "sr_issue_5",
    label: "Issue To Sample",
    value: "issue_to_sample",
    movement_type: "outgoing",
  },
  {
    id: "sr_issue_6",
    label: "Issue To Lab",
    value: "issue_to_lab",
    movement_type: "outgoing",
  },
  {
    id: "sr_issue_7",
    label: "Issue To Loose",
    value: "issue_to_cutting_loose",
    movement_type: "outgoing",
  },
  {
    id: "sr_issue_8",
    label: "Issue To Others",
    value: "issue_to_others",
    movement_type: "outgoing",
  },
  {
    id: "sr_return_1",
    label: "Return To Cutting",
    value: "return_from_cutting",
    movement_type: "incoming",
  },
  {
    id: "sr_return_2",
    label: "Return To Sewing",
    value: "return_from_sewing",
    movement_type: "incoming",
  },
  {
    id: "sr_return_3",
    label: "Return To Finishing",
    value: "return_from_folding",
    movement_type: "incoming",
  },
  {
    id: "sr_return_4",
    label: "Return To Packing",
    value: "return_from_packing",
    movement_type: "incoming",
  },
  {
    id: "sr_return_5",
    label: "Return To Sample",
    value: "return_from_sample",
    movement_type: "incoming",
  },
  {
    id: "sr_return_6",
    label: "Return To Lab",
    value: "return_from_lab",
    movement_type: "incoming",
  },
  {
    id: "sr_return_7",
    label: "Return To Loose",
    value: "return_from_cutting_loose",
    movement_type: "incoming",
  },
  {
    id: "sr_return_8",
    label: "Return To Others",
    value: "return_from_others",
    movement_type: "incoming",
  },
];

export const getStoreRequisitionMovementLabel = (value) => {
  const found = storeRequisitionMovementTypes.find((item) => item.value === value);
  return found?.label || value;
};

export const storeRequisitionSrTypes = [
  { id: 1, label: "Fabric & Interlining", value: "fabric & interlining" },
  // { id: 2, label: "Trim & Accessories", value: "trim & accessories" },
  // { id: 3, label: "Carton", value: "carton" },
];

export const getStoreRequisitionSrTypeLabel = (value) => {
  const found = storeRequisitionSrTypes.find((item) => item.value === value);
  return found?.label || value;
};

export const getItemCategoryFilterBySrType = (srType) => {
  switch (srType) {
    case "fabric & interlining":
      return { use_fabric_interlining_store: "Yes" };
    case "trim & accessories":
      return { use_fabric_interlining_store: "No" };
    case "carton":
      return { use_fabric_interlining_store: "Booking" };
    default:
      return {};
  }
};
